import { RefObject, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PlanEntitlementKey } from '../../../../../../api/graphql/generated';
import {
  FeatureTourRef,
  FeatureTourStep,
} from '../../../../../../components/feature/feature-tour';
import { PaywallSubscriptionDetail } from '../../../../../../components/paywall/paywall';

const useFlowItemFineTuneTourSteps = (
  tourRef: RefObject<FeatureTourRef>
): FeatureTourStep[] => {
  const { i18n } = useTranslation();

  const tour = useMemo(() => {
    const paywallSelector = 'fine-tune-paywall';

    return [
      {
        analyticKey: 'fine_tune_info',
        selector: paywallSelector,
        title: i18n.t('common:fine_tune'),
        description: i18n.t('common:fine_tune_desc'),
      },
      {
        analyticKey: 'fine_tune_subscription',
        selector: paywallSelector,
        title: i18n.t('common:fine_tune'),
        description: (
          <PaywallSubscriptionDetail
            planEntitlementKey={PlanEntitlementKey.WELDING_FINE_TUNE}
            onBeforeNavigate={() => {
              tourRef.current?.stopTour();
            }}
          />
        ),
      },
    ];
  }, [i18n, tourRef]);

  return tour;
};

export { useFlowItemFineTuneTourSteps };
